import type { RouteRecordRaw } from 'vue-router'

const weeklyReportH5Routes: RouteRecordRaw[] = [
  {
    path: '/t/:tenantCode/goals/weekly-report/jobs/:jobId',
    name: 'weekly-report-h5-detail',
    component: () => import('@/views/goal/WeeklyReportH5Detail.vue'),
    meta: {
      title: '自动周报',
      public: true,
    },
  },
]

export default weeklyReportH5Routes
